import React, { useState, useEffect, useMemo } from 'react';
import { withRouter, useLocation } from 'react-router-dom';

import Form from "react-jsonschema-form";

import { http, notifier } from "common";

import { artisGroupAcceptInviteUrlPath, artisGroupAssocAPIPath } from "properties/config.json";

const schema = {
  type: "object",
  required: ["artistGroupId", "artistId"],
  properties: {
    artistGroupId: {
      type: "number",
      title: "Artist Group Id",
    },
    artistId: {
      type: "number",
      title: "Artist Id",
    },
  },
};

const uiSchema = {
};

const formdata = {
  artistGroupId: -1,
  artistId: -1,
  inviteLinkUrl: "",
};

const ARTIST_GROUP_ASSOCIATE_API_PATH = "/artist/artistGroup/associate";

const ArtistGroupAssocInvite = (props) => {
  const location = useLocation();
  const [formData, setFormData] = useState({...formdata});

  const handleSubmit = (data) => {
    console.log(data);
    data.inviteLinkUrl = `${window.location.href.replace(location.pathname, '')}${artisGroupAcceptInviteUrlPath}`;
    setFormData(data);

    http
      .post(artisGroupAssocAPIPath, { ...data })
      .then((response) => {
        notifier.success("Artist associated successfully");
      })
      .catch((error) => {
        notifier.error("Artist association failed");
      });
  }

  return (
    <div style={{width:"100%", height:"100%", "align-items": "center", "justify-content": "center"}}>
      <small>location.pathname: {location.pathname}</small>
      <p/>
      <small>location.search: {location.search}</small>
      <p/>
      <small>location.hash: {location.hash}</small>
      <p/>
      <small>location.state: {location.state}</small>
      <p/>
      <small>window.location.href: {window.location.href}</small>
      <p/>
      <small>e.formData: {`${JSON.stringify(formData)}`}</small>
      <p/>
      <div>
        <Form
          idPrefix={"artistGroupAssocInviteForm"}
          schema={schema}
          uiSchema={uiSchema}
          formData={formdata}
          onSubmit={(e) => {
	    handleSubmit(e.formData);
	  }}
        >
          <div className="col-sm-12">
            <button
              type="submit"
              className="btn btn-primary btn-sm text-center"
              style={{ "width": "200px" }}
            >
              Invite
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default withRouter(ArtistGroupAssocInvite);
